import {
  SET_ADMIN_PROFILE,
  SET_COUNTERS,
  SET_COUNTER_CATEGORIES,
  SET_COUNTER_TYPES,
  SET_PROJECTS,
  SET_PROJECTS_BY_CITIES,
  SET_STATISTICS,
  SET_TYPES_INFO,
  SET_USERS,
  SET_USER_INFO,
  UPDATE_ACCESS_TABLE,
  UPDATE_ADMINS_TABLE,
  UPDATE_BILLS_TABLE,
  UPDATE_COUNTERS_LIST,
  UPDATE_COUNTER_TYPES,
  UPDATE_PROFILE,
  UPDATE_PROJECTS_LIST,
  UPDATE_SHOW_COUNTER_LIST_MODE,
  UPDATE_SHOW_COUNTER_TYPE_LIST_MODE,
  UPDATE_SHOW_PROJECTS_LIST_MODE,
  UPDATE_SHOW_USERS_LIST_MODE,
  UPDATE_USERS_LIST,
  UPDATE_SHOW_PROJECT_WATER_COUNTERS_LIST_MODE,
  UPDATE_SHOW_PROJECT_POWER_COUNTERS_LIST_MODE,
  UPDATE_SHOW_PROJECT_GAS_COUNTERS_LIST_MODE,
  UPDATE_PROJECT_COUNTER_TYPES,
  UPDATE_PROJECT,
  UPDATE_NAVIGATIONS,
} from "./Types";

export const SetUserInfo = (payload) => {
  return {
    type: SET_USER_INFO,
    payload: payload,
  };
};

export const SetProjects = (payload) => {
  return {
    type: SET_PROJECTS,
    payload: payload,
  };
};

export const UpdateProjectsList = (payload) => {
  return {
    type: UPDATE_PROJECTS_LIST,
    payload: payload,
  };
};

export const SetUsers = (payload) => {
  return {
    type: SET_USERS,
    payload: payload,
  };
};

export const UpdateUsersList = (payload) => {
  return {
    type: UPDATE_USERS_LIST,
    payload: payload,
  };
};

export const SetCounterTypes = (payload) => {
  return {
    type: SET_COUNTER_TYPES,
    payload: payload,
  };
};

export const UpdateCounterTypes = (payload) => {
  return {
    type: UPDATE_COUNTER_TYPES,
    payload: payload,
  };
};

export const SetCounters = (payload) => {
  return {
    type: SET_COUNTERS,
    payload: payload,
  };
};

export const UpdateCountersList = (payload) => {
  return {
    type: UPDATE_COUNTERS_LIST,
    payload: payload,
  };
};

export const SetStatistics = (payload) => {
  return {
    type: SET_STATISTICS,
    payload: payload,
  };
};

export const SetProjectsByCities = (payload) => {
  return {
    type: SET_PROJECTS_BY_CITIES,
    payload: payload,
  };
};

export const SetTypesInfo = (payload) => {
  return {
    type: SET_TYPES_INFO,
    payload: payload,
  };
};

export const SetAdminProfile = (payload) => {
  return {
    type: SET_ADMIN_PROFILE,
    payload: payload,
  };
};

export const SetCounterCategories = (payload) => {
  return {
    type: SET_COUNTER_CATEGORIES,
    payload: payload,
  };
};

export const UpdateProfile = (payload) => {
  return {
    type: UPDATE_PROFILE,
    payload: payload,
  };
};

export const UpdateShowUsersListMode = (payload) => {
  return {
    type: UPDATE_SHOW_USERS_LIST_MODE,
    payload: payload,
  };
};

export const UpdateShowProjectListMode = (payload) => {
  return {
    type: UPDATE_SHOW_PROJECTS_LIST_MODE,
    payload: payload,
  };
};

export const UpdateShowCounterTypeListMode = (payload) => {
  return {
    type: UPDATE_SHOW_COUNTER_TYPE_LIST_MODE,
    payload: payload,
  };
};

export const UpdateShowCounterListMode = (payload) => {
  return {
    type: UPDATE_SHOW_COUNTER_LIST_MODE,
    payload: payload,
  };
};

export const UpdateAccessTable = (payload) => {
  return {
    type: UPDATE_ACCESS_TABLE,
    payload: payload,
  };
};

export const UpdateAdminsTable = (payload) => {
  return {
    type: UPDATE_ADMINS_TABLE,
    payload: payload,
  };
};

export const UpdateBillsTable = (payload) => {
  return {
    type: UPDATE_BILLS_TABLE,
    payload: payload,
  };
};

export const UpdateShowProjectWaterCountersListMode = (payload) => {
  return {
    type: UPDATE_SHOW_PROJECT_WATER_COUNTERS_LIST_MODE,
    payload: payload,
  };
};

export const UpdateShowProjectPowerCountersListMode = (payload) => {
  return {
    type: UPDATE_SHOW_PROJECT_POWER_COUNTERS_LIST_MODE,
    payload: payload,
  };
};

export const UpdateShowProjectGasCountersListMode = (payload) => {
  return {
    type: UPDATE_SHOW_PROJECT_GAS_COUNTERS_LIST_MODE,
    payload: payload,
  };
};

export const UpdateProjectCounterTypes = (payload) => {
  return {
    type: UPDATE_PROJECT_COUNTER_TYPES,
    payload: payload,
  };
};

export const UpdateProject = (payload) => {
  return {
    type: UPDATE_PROJECT,
    payload: payload,
  };
};

export const UpdateNavigations = (payload) => {
  return {
    type: UPDATE_NAVIGATIONS,
    payload: payload,
  };
};
